import axiosInstance from './config/api';
import type { ActivityByHour, AgentPerformance, Operational } from './AgentCenterAPI';

export type ManagerAgentAnalyticsStatus = 'offline' | 'online' | 'oncall';

export interface ManagerAgentAnalyticsItem {
    id: string;
    name: string;
    status: ManagerAgentAnalyticsStatus;
    agentPerformance: AgentPerformance;
    operational: Operational;
}

export interface ManagerAgentsAnalyticsResponse {
    timezone: string;
    activityByHour: ActivityByHour;
    agents: ManagerAgentAnalyticsItem[];
}

export type { AgentPerformance, Operational, ActivityByHour };

export const getManagerAgentsAnalytics = () => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return axiosInstance
        .get<ManagerAgentsAnalyticsResponse>('/manager-command-center/analytics/agents', {
            params: { tz },
            suppressErrorToast: true,
        })
        .then((res) => res.data);
};
